import { render, staticRenderFns } from "./LeiloesFechado.vue?vue&type=template&id=4ccb8aed"
import script from "./LeiloesFechado.vue?vue&type=script&lang=js"
export * from "./LeiloesFechado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports